import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e3a90c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modify_wrap" }
const _hoisted_2 = { class: "modify_steps" }
const _hoisted_3 = {
  onsubmit: "return false",
  class: "modify_form"
}
const _hoisted_4 = {
  key: 0,
  class: "modify_input"
}
const _hoisted_5 = { class: "modify_input_line" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modify_input_line_name" }, "旧密码：", -1))
const _hoisted_7 = {
  key: 0,
  class: "modify_input_line_old"
}
const _hoisted_8 = { class: "modify_input_line" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modify_input_line_name" }, "新密码：", -1))
const _hoisted_10 = { class: "modify_input_line_level" }
const _hoisted_11 = {
  key: 1,
  class: "modify_input"
}
const _hoisted_12 = { class: "modify_input_line" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modify_input_line_name" }, "确认密码：", -1))
const _hoisted_14 = { class: "modify_input_errors" }
const _hoisted_15 = { class: "modify_input_line" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modify_input_line_name" }, "验证码：", -1))
const _hoisted_17 = { class: "input_line_code" }
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  key: 2,
  class: "modify_input"
}
const _hoisted_20 = { class: "modify_input_line" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modify_input_line_name" }, "验证码输入：", -1))
const _hoisted_22 = { class: "modify_input_phone" }
const _hoisted_23 = { class: "modify_input_code" }
const _hoisted_24 = {
  key: 3,
  class: "modify_input"
}
const _hoisted_25 = { class: "modify_input_line" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modify_input_line_name" }, "确认手机号：", -1))
const _hoisted_27 = { class: "modify_input_phone" }
const _hoisted_28 = { class: "modify_input_code" }
const _hoisted_29 = { class: "modify_input_line" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modify_input_line_name" }, "验证码输入：", -1))
const _hoisted_31 = {
  key: 4,
  class: "modify_input"
}
const _hoisted_32 = { class: "modify_input_line" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modify_input_line_name" }, "验证码输入：", -1))
const _hoisted_34 = { class: "modify_input_phone" }
const _hoisted_35 = { class: "modify_input_code" }
const _hoisted_36 = {
  key: 5,
  class: "modify_input"
}
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { class: "modify_input_tips" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "请确保您输入的邮箱能正常接收激活邮件，新邮箱才能生效", -1))
const _hoisted_40 = {
  key: 0,
  class: "modify_input_line"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modify_input_line_name" }, "原邮箱：", -1))
const _hoisted_42 = { class: "input_line_mailbox" }
const _hoisted_43 = { class: "modify_input_line" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modify_input_line_name" }, "新邮箱：", -1))
const _hoisted_45 = {
  key: 1,
  class: "modify_input_mail"
}
const _hoisted_46 = { class: "mail_top" }
const _hoisted_47 = ["src"]
const _hoisted_48 = { class: "mail_top_text" }
const _hoisted_49 = { class: "mail_top_texts" }
const _hoisted_50 = { class: "modify_input_line" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modify_input_line_name" }, "验证码输入：", -1))
const _hoisted_52 = { class: "modify_input_phone" }
const _hoisted_53 = { class: "explain" }
const _hoisted_54 = { class: "explain_content" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "explain_left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "explain_left_title" }, "说明"),
  /*#__PURE__*/_createElementVNode("div", { class: "explain_left_text" }, "一直没有收到邮件？"),
  /*#__PURE__*/_createElementVNode("div", { class: "explain_left_text" }, "请检查是否存在垃圾邮件中。如果还未收到请再")
], -1))
const _hoisted_56 = { class: "explain_btn" }
const _hoisted_57 = { class: "btn_again_countdown" }
const _hoisted_58 = {
  key: 6,
  class: "modify_next"
}
const _hoisted_59 = {
  key: 7,
  class: "modify_accomplish"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modify_accomplish_text" }, "操作成功", -1))
const _hoisted_61 = { class: "modify_accomplish_tips" }
const _hoisted_62 = { class: "modify_accomplish_tips" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_step = _resolveComponent("a-step")!
  const _component_a_steps = _resolveComponent("a-steps")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_statistic_countdown = _resolveComponent("a-statistic-countdown")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_InfoCircleFilled = _resolveComponent("InfoCircleFilled")!
  const _component_CloseOutlined = _resolveComponent("CloseOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_CheckCircleFilled = _resolveComponent("CheckCircleFilled")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.oldPasswordStatus)
      ? (_openBlock(), _createBlock(_component_a_alert, {
          key: 0,
          class: "custom_menu_alert",
          message: _ctx.alert,
          type: "warning",
          banner: "",
          closable: ""
        }, null, 8, ["message"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_steps, { current: _ctx.current }, {
        default: _withCtx(() => [
          _createVNode(_component_a_step, {
            title: _ctx.stepList[_ctx.routerId].one
          }, null, 8, ["title"]),
          _createVNode(_component_a_step, {
            title: _ctx.stepList[_ctx.routerId].two
          }, null, 8, ["title"]),
          _createVNode(_component_a_step, {
            title: _ctx.stepList[_ctx.routerId].three
          }, null, 8, ["title"])
        ]),
        _: 1
      }, 8, ["current"])
    ]),
    _createElementVNode("form", _hoisted_3, [
      (_ctx.current == 0 && _ctx.routerId == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_a_input_password, {
                value: _ctx.password.oldPassword,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password.oldPassword) = $event)),
                placeholder: "请设置最少六位长度的密码",
                size: "small",
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.password.oldPassword = _ctx.password.oldPassword.replace(/\s+/g, ''))),
                autocomplete: "off"
              }, null, 8, ["value"]),
              (_ctx.oldPasswordStatus)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, "*首次设置不需要填写旧密码"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_a_input_password, {
                value: _ctx.password.newPassword,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password.newPassword) = $event)),
                placeholder: "请设置最少六位长度的密码",
                size: "small",
                autocomplete: "off",
                onChange: _ctx.getPasswordLevel,
                onPressEnter: _ctx.rules,
                onBlur: _ctx.rules
              }, null, 8, ["value", "onChange", "onPressEnter", "onBlur"]),
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.passwordLevel), 1),
              _createElementVNode("div", {
                class: "modify_input_line_rule",
                style: _normalizeStyle({ color: _ctx.passwordText ? '#ff4d4f' : '' })
              }, _toDisplayString(_ctx.passwordText ? _ctx.passwordText : '6-16位字符，可包含数字、特殊字符、字母(区分大小写)'), 5)
            ])
          ]))
        : (_ctx.current == 1 && _ctx.routerId == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_a_input_password, {
                  value: _ctx.password.newsPassword,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.password.newsPassword) = $event)),
                  placeholder: "请设置最少六位长度的密码",
                  size: "small",
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.password.newsPassword = _ctx.password.newsPassword.replace(/\s+/g, ''))),
                  autocomplete: "off"
                }, null, 8, ["value"]),
                _withDirectives(_createElementVNode("div", _hoisted_14, "两次输入不一致", 512), [
                  [_vShow, _ctx.error]
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_a_input, {
                    value: _ctx.password.code,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.password.code) = $event)),
                    placeholder: "请输入验证码",
                    size: "small",
                    maxlength: 4
                  }, null, 8, ["value"]),
                  _createElementVNode("img", {
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.switchCode && _ctx.switchCode(...args))),
                    src: _ctx.codeImg
                  }, null, 8, _hoisted_18)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
      (_ctx.current == 0 && _ctx.routerId == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_a_input, {
                  placeholder: "请输入验证码",
                  size: "small",
                  value: _ctx.mobile.oldCode,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.mobile.oldCode) = $event))
                }, {
                  suffix: _withCtx(() => [
                    _withDirectives(_createElementVNode("div", {
                      style: {"cursor":"pointer"},
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.sendCode && _ctx.sendCode(...args)))
                    }, "发送验证码", 512), [
                      [_vShow, _ctx.mobile.countDown == 0]
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_23, [
                      _createTextVNode(" 获取验证码（ "),
                      _createVNode(_component_a_statistic_countdown, {
                        value: _ctx.mobile.countDown,
                        format: "s",
                        onFinish: _ctx.onFinishMobile
                      }, null, 8, ["value", "onFinish"]),
                      _createTextVNode(" ） ")
                    ], 512), [
                      [_vShow, _ctx.mobile.countDown > 0]
                    ])
                  ]),
                  _: 1
                }, 8, ["value"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.current == 1 && _ctx.routerId == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_a_select, {
                  class: "input_phone_select",
                  placeholder: "+86",
                  disabled: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: "86" }, {
                      default: _withCtx(() => [
                        _createTextVNode("+86")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_input, {
                  class: "input_phone_input",
                  placeholder: "请输入手机号",
                  size: "large",
                  value: _ctx.mobile.newMobile,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.mobile.newMobile) = $event))
                }, {
                  suffix: _withCtx(() => [
                    _withDirectives(_createElementVNode("div", {
                      style: {"cursor":"pointer"},
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.sendNewCode && _ctx.sendNewCode(...args)))
                    }, "发送验证码", 512), [
                      [_vShow, _ctx.mobile.newCountDown == 0]
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_28, [
                      _createTextVNode(" 获取验证码（ "),
                      _createVNode(_component_a_statistic_countdown, {
                        value: _ctx.mobile.newCountDown,
                        format: "s",
                        onFinish: _ctx.onFinishMobile
                      }, null, 8, ["value", "onFinish"]),
                      _createTextVNode(" ） ")
                    ], 512), [
                      [_vShow, _ctx.mobile.newCountDown > 0]
                    ])
                  ]),
                  _: 1
                }, 8, ["value"])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createVNode(_component_a_input, {
                placeholder: "请输入验证码",
                size: "large",
                value: _ctx.mobile.newCode,
                "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.mobile.newCode) = $event))
              }, null, 8, ["value"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.current == 0 && _ctx.routerId == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_component_a_input, {
                  placeholder: "请输入验证码",
                  size: "large",
                  value: _ctx.email.code,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.email.code) = $event))
                }, {
                  suffix: _withCtx(() => [
                    _withDirectives(_createElementVNode("div", {
                      style: {"cursor":"pointer"},
                      onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.sendCode && _ctx.sendCode(...args)))
                    }, "发送验证码", 512), [
                      [_vShow, _ctx.mobile.countDown == 0]
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_35, [
                      _createTextVNode(" 获取验证码（ "),
                      _createVNode(_component_a_statistic_countdown, {
                        value: _ctx.mobile.countDown,
                        format: "s",
                        onFinish: _ctx.onFinishMobile
                      }, null, 8, ["value", "onFinish"]),
                      _createTextVNode(" ） ")
                    ], 512), [
                      [_vShow, _ctx.mobile.countDown > 0]
                    ])
                  ]),
                  _: 1
                }, 8, ["value"])
              ])
            ])
          ]))
        : (_ctx.current == 1 && _ctx.routerId == 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
              (_ctx.send_mailbox)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _withDirectives(_createElementVNode("div", _hoisted_38, [
                      _createVNode(_component_InfoCircleFilled, { class: "infoCircleFilled" }),
                      _hoisted_39,
                      _createVNode(_component_CloseOutlined, {
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.modifyTips = false)),
                        class: "closeOutlined"
                      })
                    ], 512), [
                      [_vShow, _ctx.modifyTips]
                    ]),
                    (_ctx.text !== '未绑定')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                          _hoisted_41,
                          _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.text), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_43, [
                      _hoisted_44,
                      _createVNode(_component_a_input, {
                        value: _ctx.email.email,
                        "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.email.email) = $event)),
                        placeholder: "请输入新邮箱",
                        size: "large"
                      }, null, 8, ["value"])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("img", { src: _ctx.mail }, null, 8, _hoisted_47),
                      _createElementVNode("div", _hoisted_48, [
                        _createTextVNode(" 邮件已发送到您的邮箱 "),
                        _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.email.email), 1),
                        _createTextVNode(" 请输入验证码，完成修改。 "),
                        _createVNode(_component_a_button, {
                          class: "mail_top_btn",
                          type: "primary",
                          onClick: _ctx.toNext
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 下一步 ")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      _hoisted_51,
                      _createElementVNode("div", _hoisted_52, [
                        _createVNode(_component_a_input, {
                          placeholder: "请输入验证码",
                          size: "large",
                          value: _ctx.email.codes,
                          "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.email.codes) = $event))
                        }, null, 8, ["value"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("div", _hoisted_54, [
                        _hoisted_55,
                        _createElementVNode("div", _hoisted_56, [
                          _createVNode(_component_a_button, {
                            class: _normalizeClass(_ctx.email.countDown == 0 ? '' : 'explain_btn_again'),
                            type: "primary",
                            onClick: _ctx.sendEmail
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("div", _hoisted_57, [
                                _createTextVNode(" （"),
                                _createVNode(_component_a_statistic_countdown, {
                                  value: _ctx.email.countDown,
                                  format: "s",
                                  onFinish: _ctx.onFinishMobile
                                }, null, 8, ["value", "onFinish"]),
                                _createTextVNode("秒后） ")
                              ], 512), [
                                [_vShow, _ctx.email.countDown !== 0]
                              ]),
                              _createTextVNode(" 重新发送邮件 ")
                            ]),
                            _: 1
                          }, 8, ["class", "onClick"])
                        ])
                      ])
                    ])
                  ]))
            ]))
          : _createCommentVNode("", true),
      (_ctx.current == 0 || (_ctx.current == 1 && _ctx.send_mailbox))
        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: _ctx.toNext
            }, {
              default: _withCtx(() => [
                _createTextVNode("下一步")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.current == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
            _createVNode(_component_CheckCircleFilled, { class: "checkCircleFilled" }),
            _hoisted_60,
            _withDirectives(_createElementVNode("div", _hoisted_61, "请返回重新登入", 512), [
              [_vShow, _ctx.routerId !== 2]
            ]),
            _createElementVNode("div", _hoisted_62, [
              _createVNode(_component_a_statistic_countdown, {
                value: _ctx.deadline,
                onFinish: _ctx.onFinish,
                format: "s"
              }, null, 8, ["value", "onFinish"]),
              _createTextVNode(" 秒后" + _toDisplayString(_ctx.routerId == 2 ? '返回安全设置页面' : '跳转登录页面'), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}